import { APIProvider } from '@vis.gl/react-google-maps';

interface GoogleMapsProviderProps {
  children: React.ReactNode;
}

export function GoogleMapsProvider({ children }: GoogleMapsProviderProps) {
  const API_KEY = 'AIzaSyDOMCcEqcpRrRSLc4jfJdKFcgYz60ghq6c';

  return (
    <APIProvider
      apiKey={API_KEY}
      language="es"
      region="ES"
    >
      {children}
    </APIProvider>
  );
}